import { createSelector } from 'reselect';
import { actualUser } from './user';

export const selectSubscription = (id) =>
  createSelector(
    (state) => state.Subscription.subscriptions,
    (subscriptions) =>
      subscriptions.find((subscription) => subscription.id === id),
  );

export const selectSubscriptionByUserId = (userId) =>
  createSelector(
    (state) => state.Subscription.subscriptions,
    (subscriptions) =>
      subscriptions.find((subscription) => subscription.userId === userId),
  );

export const actualSubscription = createSelector(
  actualUser,
  (state) => state.Subscription.subscriptions,
  (user, subscriptions) =>
    subscriptions.find((subscription) => subscription.userId === user?.id),
);

export const totalSubscriptions = createSelector(
  (state) => state.Subscription.subscriptions,
  (subscriptions) => subscriptions.length,
);

export const totalRevenues = createSelector(
  (state) => state.Subscription.subscriptions,
  (subscriptions) =>
    subscriptions.reduce((acc, subscription) => acc + subscription.amount, 0),
);
